import React from 'react';
import { GlobalStyles as MuiGlobalStyles } from '@mui/material';

export default function GlobalStyles() {
  return (
    <MuiGlobalStyles
      styles={{
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box',
        },
        html: {
          width: '100%',
          height: '100%',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          width: '100%',
          maxWidth: '100%',
          height: '100%',
          overflowX: 'hidden',
          margin: 0,
          padding: 0,
        },
        '#root': {
          width: '100%',
          maxWidth: '100%',
          height: '100%',
          overflowX: 'hidden',
        },
        '.MuiContainer-root': {
          paddingLeft: '16px',
          paddingRight: '16px',
          marginLeft: 0,
          marginRight: 0,
          maxWidth: '100% !important',
        },
        // Add any other global styles here
      }}
    />
  );
}
